import { SilverfinFlash } from '@app/types/index'
import { ApplicationContext } from './shared-types'

import flowRight from 'lodash/flowRight'
import SfFlashManager from '@app/application/layout/sections/sf-flash-manager/sf-flash-manager.vue'
import { createApp } from '@app/adapters/create-app'

const addFlash =
  ({ eventHub }: ApplicationContext): SilverfinFlash['addFlash'] =>
  (type, message) => {
    eventHub.$emit('sf-flash-manager:add-banners', [[type, message]])
  }

const setFlashMessages =
  ({ eventHub }: ApplicationContext): SilverfinFlash['setFlashMessages'] =>
  (messageList) => {
    eventHub.$emit('sf-flash-manager:add-banners', messageList)
  }

const createSfFlash = (appContext: ApplicationContext): SilverfinFlash => {
  return {
    setFlashMessages: setFlashMessages(appContext),
    addFlash: addFlash(appContext),
  }
}

const provideSfFlashGlobally = (
  env: ApplicationContext
): ApplicationContext => {
  const { globalObject } = env

  globalObject.SilverfinFlash = createSfFlash(env)

  return env
}

const mountSfFlashManager = (env: ApplicationContext): ApplicationContext => {
  const { onDomLoad } = env

  onDomLoad(($dom) => {
    const flashContainer = $dom[0].querySelector(
      '#flash-js-managed'
    ) as HTMLElement

    if (flashContainer) {
      createApp(SfFlashManager).mount(flashContainer)
    }
  })

  return env
}

export default flowRight([provideSfFlashGlobally, mountSfFlashManager])
